import { __ } from '@wordpress/i18n';

import { NON_REGISTRABLE_STATUS } from '@constants/NON_REGISTRABLE_STATUS';
import { handleEuneosRegisterClick, checkIfRegistrable } from '@utils';

const parseSlug = (url) => {
	return url.split('/').filter(Boolean).pop();
};

/**
 * Get status
 * @returns {JSX.Element}
 */
const CourseListItemButtons = ({ id, url, status, registrationUrl }) => {
	const { cartUrl, archiveUrl } = window.visitEduSettings;

	return (
		<div className="upcoming-event-list__item__buttons">
			<div className="wp-block-button is-style-fill">
				<a
					href={archiveUrl + parseSlug(url)}
					className="wp-block-button__link"
				>
					{__('View', 'kotisivu-block-theme')}
				</a>
			</div>
			{checkIfRegistrable({ status }) && (
				<div className="wp-block-button is-style-outline">
					<a
						href={registrationUrl}
						className="wp-block-button__link"
						target="_blank"
						rel="noreferrer noopener"
						data-track="true"
						data-track-event="link_click"
						data-track-action="register"
						data-track-label={id}
						onClick={() => handleEuneosRegisterClick(id)}
					>
						{__('Register', 'kotisivu-block-theme')}
					</a>
				</div>
			)}
		</div>
	);
};

export default CourseListItemButtons;
